import { combineReducers } from 'redux'
import { asyncExpensesReducer } from './expensesReducer'

const rootReducer = combineReducers({ asyncExpensesReducer })

export default rootReducer
